export type DisplayNameEntity = {
  DisplayName?: string | null;
  Name: string;
};

/**
 * Returns the user-facing label for entities with DisplayName and Name fields.
 * Uses `DisplayName || Name` so an empty DisplayName falls back to Name.
 */
export function getDisplayNameOrNameLabel(entity: DisplayNameEntity | null | undefined): string {
  if (entity == null) {
    return '';
  }
  return entity.DisplayName || entity.Name || '';
}

/**
 * Compares by DisplayName || Name, using fallback values when entity labels are unavailable.
 */
export function compareDisplayNameOrName(
  a: DisplayNameEntity | null | undefined,
  b: DisplayNameEntity | null | undefined,
  fallbackA?: string | null,
  fallbackB?: string | null
): number {
  const labelA = getDisplayNameOrNameLabel(a) || fallbackA || '';
  const labelB = getDisplayNameOrNameLabel(b) || fallbackB || '';
  const cmp = labelA.localeCompare(labelB);
  if (cmp !== 0) {
    return cmp;
  }
  return (a?.Name || fallbackA || '').localeCompare(b?.Name || fallbackB || '');
}
